/*
 * @Description: 
 */
import { RuntimeConfig, useSelector, useDispatch, } from 'umi';
import { LogoutOutlined, KeyOutlined, } from '@ant-design/icons';
import { Dropdown, } from 'antd';

import { goToLogin } from '@/utils';
import { ROLE_TYPE } from '@/utils/const';

export const dva: RuntimeConfig['dva'] = {
  config: {
    onError(err: Error) {
      // return Promise.reject(err);
    },
  },
};

export const locale: RuntimeConfig['locale'] = {
  onError: (err) => {
    // TODO: 会一直报错，不知道为啥
    // console.log('error handler...', err);
  }
};

export const layout: RuntimeConfig['layout'] = () => {
  const dispatch = useDispatch();

  const userInfo = useSelector((state: any) => state.global.userInfo);

  const handleMenuClick = ({ key }: any) => {
    if (key === 'changePassword') {
      dispatch({
        type: 'global/_setState',
        payload: {
          isOpenChangePassword: true,
        },
      });
    } else if (key === 'logout') {
      goToLogin();
    }
  };
  
  return {
    // logo: 'https://res.miaocode.com/web-3.0/login-logo-1707297793140.png',
    logo: 'https://res.miaocode.com/web/1-2024-11-07-17-26-52.png',
    title: 'MIAO Teacher',
    layout: 'top',
    menu: {
      defaultOpenAll: true,
    },
    breadcrumbRender: (route = []) => [
      {
        path: '/',
        breadcrumbName: 'Home',
      },
      ...route,
    ],
    avatarProps: {
      src: '',
      title: userInfo.accountName,
      render: (props, dom) => {
        return (
          <Dropdown
            menu={{
              items: [
                {
                  key: 'changePassword',
                  icon: <KeyOutlined />,
                  label: 'Change Password',
                },
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: 'Logout',
                },
              ],
              onClick: handleMenuClick,
            }}
          >
            {dom}
          </Dropdown>
        );
      },
    }
  };
};

export async function getInitialState(): Promise<{
  role?: ROLE_TYPE;
  orgName?: string;
}> {
  return {}; // FIXME: 暂时不需要权限管理
  // try {
  //   const res = await getCurrentResellerInfo();
  //   const userInfo = res.data || {};
  //   return {
  //     role: userInfo.resellerType === null || userInfo.resellerType === undefined ? ROLE_TYPE.ADMIN : userInfo.resellerType,
  //     orgName: userInfo.orgName,
  //   };
  // } catch (error) {
  //   console.error('getInitialState error:', error);
  //   return {};
  // }
}

